import React from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../../components/alert/alert.component";

import { edit, retreive } from "../../../actions/homeAds";
import { withRouter } from "../../../utils/withRouter";

class Edit extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      adUrl: "",
      adUrl1: "",
      adUrl2: "",
      adUrl3: "",
      images: [],
      ad1: "",
      ad2: "",
      ad3: "",
      ad4: "",
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    const id = this.props.location.search.substr(4);
    const res = await this.props.retreive(id);
    if (res) {
      this.setState({
        adUrl1: res.adUrl1,
        adUrl2: res.adUrl2,
        adUrl3: res.adUrl3,
        adUrl4: res.adUrl4,
        loading: false,
      });
    }
    console.log(
      this.state.adUrl1,
      this.state.adUrl2,
      this.state.adUrl3,
      this.state.adUrl4
    );
    if (!res) {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _submitHandler = async () => {
    const id = this.props.location.search.substr(4);

    const {
      adUrl4,
      adUrl1,
      adUrl2,
      adUrl3,
      ad1,
      ad2,
      ad3,
      ad4,
    } = this.state;

    let formData = new FormData();
    formData.append("adUrl1", adUrl1);
    formData.append("adUrl2", adUrl2);
    formData.append("adUrl3", adUrl3);
    formData.append("adUrl4", adUrl4);
    formData.append("ad1", ad1);
    formData.append("ad2", ad2);
    formData.append("ad3", ad3);
    formData.append("ad4", ad4);
    formData.append("homeAdsId", id);

    // for (var i = 0; i < images.length; i++) {
    //   formData.append("images", images[i]);
    // }

    this.setState({ loading: true });

    const res = await this.props.edit(formData);

    this.setState({ loading: false });

    if (res) {
      this.setState({
        loading: false,
      });
      toast(`${res}`, { containerId: "B" });
    }
  };

  _handleImageChange(e) {
    e.preventDefault();
    console.log(e.target.files[0]);
    var name = e.target.name;
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        [name]: file,
      });
    };
    reader.readAsDataURL(file);
    console.log(this.state.ad1);
  }

  render() {
    TopBarProgress.config({
      barThickness: 4,
      barColors: {
        "0": "rgb(51, 201, 45, .7)",
        ".3": "rgb(255, 77, 107, .7)",
        "1.0": "rgb(200, 125, 255, .7)",
      },
      shadowBlur: 5,
      shadowColor: "rgba(0, 0, 0, .5)",
    });
    return (
      <div className="container-scroller">
        {this.state.loading && <TopBarProgress />}

        <ToastContainer
        stacked 
          enableMultiContainer
          containerId={"B"}
          // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
        />

        <div className="page-header">
          <h3 className="page-title"> Edit Home Ad </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/admin/banners">Home Ads</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit Home Ads
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Edit Home Ad</h4>

                <Alert />

                <form className="forms-sample">
                  <div className="form-group">
                    <label htmlFor="exampleInputName1">Home Ad One Url</label>
                    <input
                      type="text"
                      className="form-control"
                      id="url"
                      placeholder="Url"
                      name="adUrl1"
                      value={this.state.adUrl1 && this.state.adUrl1}
                      onChange={(e) =>
                        this.setState({ adUrl1: e.target.value })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Ad 1 Image</label>

                    <div className="input-group col-xs-12">
                      <input
                        required
                        type="file"
                        name="ad1"
                        className="form-control"
                        onChange={(e) => this._handleImageChange(e)}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputName1">Home Ad Two Url</label>
                    <input
                      type="text"
                      className="form-control"
                      id="url"
                      placeholder="Url"
                      name="adUrl2"
                      value={this.state.adUrl2 && this.state.adUrl2}
                      onChange={(e) =>
                        this.setState({ adUrl2: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>Ad two Image</label>

                    <div className="input-group col-xs-12">
                      <input
                        required
                        type="file"
                        name="ad2"
                        className="form-control"
                        onChange={(e) => this._handleImageChange(e)}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputName1">Home Ad Three Url</label>
                    <input
                      type="text"
                      className="form-control"
                      id="url"
                      placeholder="Url"
                      name="adUrl3"
                      value={this.state.adUrl3 && this.state.adUrl3}
                      onChange={(e) =>
                        this.setState({ adUrl3: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>Ad Three Image</label>

                    <div className="input-group col-xs-12">
                      <input
                        required
                        type="file"
                        name="ad3"
                        className="form-control"
                        onChange={(e) => this._handleImageChange(e)}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputName1">Home Ad four Url</label>
                    <input
                      type="text"
                      className="form-control"
                      id="url"
                      placeholder="Url"
                      name="adUrl4"
                      value={this.state.adUrl4 && this.state.adUrl4}
                      onChange={(e) =>
                        this.setState({ adUrl4: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>Ad four Image</label>

                    <div className="input-group col-xs-12">
                      <input
                        required
                        type="file"
                        name="ad4"
                        className="form-control"
                        onChange={(e) => this._handleImageChange(e)}
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      this._submitHandler();
                    }}
                    type="button"
                    className="btn btn-primary mr-2"
                  >
                    Update
                  </button>
                  <Link to={"/admin/banners"}>
                  <button
                    className="btn btn-light"

                  >
                    Cancel
                  </button>
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

retreive.propTypes = {
  retreive: PropTypes.func.isRequired,
};
edit.propTypes = {
  edit: PropTypes.func.isRequired,
};

export default withRouter(connect(null, { retreive, edit })(Edit));
